import 'ion-rangeslider'

const {__, _x, _n, _nx} = wp.i18n;

class VpsBitrix {
    constructor() {
        this.bitrixForm = document.querySelector('.vps-bitrix')
        if (!this.bitrixForm) return false;
        this.tariffsData = [];
        this.plan = document.querySelector('.bitrix-vps__plan input');
        this.bitrixFormID = this.bitrixForm.getAttribute('id').replace('gform_', '');
        this.sliders = document.querySelectorAll('.vps-bitrix__range')
        this.stepsObject = {}
        this.slidersInstances = {}
        this.periods = document.querySelectorAll('.vps-bitrix__period');
        this.shareButton = document.querySelector('.vps-bitrix__share');
        this.checkoutButton = document.querySelector('.vps-bitrix__checkout-btn');

        this.init();
        this.events()
    }

    init() {
        this.getBitrixTariffsParams();
        this.getStepsObject(this.sliders);
        this.setSliders();
        this.totalPriceHandler();
    }

    events() {
        this.checkoutButton.addEventListener('click', this.checkoutHandler.bind(this))
        this.shareButton.addEventListener('click', this.shareHandler.bind(this));
        gform.addAction('gform_input_change', this.totalPriceHandler.bind(this));
        gform.addAction('gform_input_change', this.toggleProfit.bind(this));
        gform.addAction('gform_input_change', this.changeImage.bind(this));
        gform.addAction('gform_input_change', this.reInitConditions.bind(this));
    }

    getStepsObject() {
        this.sliders.forEach(slider => {
            const key = this.getSliderName([...slider.classList]);
            this.stepsObject[key] = slider.querySelector('.gfield_description').textContent.split(',');
        });

        return this.stepsObject;
    }

    setSliders() {
        const urlParams = new URL(window.location.href);
        this.sliders.forEach(slider => {
            let tariff = '';
            if (urlParams) {
                tariff = this.tariffsData.filter(tariff => tariff.plan === urlParams.searchParams.get('plan'))[0]
            }
            const input = slider.querySelector('input');
            const steps = slider.querySelector('.ginput_container_number + .gfield_description').textContent.split(',');
            const name = this.getSliderName([...slider.classList])
            const from = tariff ? steps.indexOf(tariff[name].toString()) : 0;
            $(input).ionRangeSlider({
                skin: "big",
                grid: true,
                from: from,
                values: steps,
                onChange: (data) => this.syncSliders(data),
            });
            this.slidersInstances[name] = $(input).data('ionRangeSlider');
            this.renderSliderNumber(slider, tariff ? tariff[name] : steps[0])
        })
    }

    renderSliderNumber(slider, value) {
        const source = slider.querySelector('.ginput_container_number');
        const html = `<div class="vps-bitrix__range-number">${value}</div>`;
        source.insertAdjacentHTML('beforeend', html)
    }

    setSliderNumber(slider) {
        slider.querySelector('.vps-bitrix__range-number').textContent = slider.querySelector('.irs-single').textContent;
    }

    syncSliders(data) {
        const currentSliderName = this.getSliderName([...data.input[0].closest('.vps-bitrix__range').classList])
        this.sliders.forEach(slider => {
            const name = this.getSliderName([...slider.classList])
            if (currentSliderName !== name) {
                this.slidersInstances[name].update({
                    from: data.from
                });
            }
            this.setSliderNumber(slider);
        });

        this.tariffsData.forEach(tariff => {
            if (tariff[currentSliderName] === data.from_value) {
                this.plan.value = tariff.plan;
            }
        })
        this.totalPriceHandler();
        this.changeImage();
        this.reInitConditions()

    }

    reInitConditions() {
        try {
            const ids = this.getFieldsID();
            window.gf_apply_rules(this.bitrixFormID, ids, false)
        } catch (err) {
            // console.log(err)
        }
    }

    checkoutHandler(e) {
        e.preventDefault();
        const contactsBlock = document.querySelector('.vps-bitrix__contacts');
        contactsBlock.classList.toggle('vps-bitrix__contacts--active')
        this.bitrixForm.classList.toggle('vps-bitrix--active')
    }

    shareHandler(e) {
        e.preventDefault();
        let timeout = 0;
        const url = new URL(window.location.href)
        const copyUrl = `${url.protocol}//${url.host}${url.pathname}?plan=${this.plan.value}`;
        const alert = document.querySelector('.vps-bitrix__share-alert');
        alert.classList.remove('vps-bitrix__share-alert--active')

        navigator.clipboard.writeText(copyUrl).then(r => {
            alert.classList.add('vps-bitrix__share-alert--active')
            timeout = setTimeout(() => alert.classList.remove('vps-bitrix__share-alert--active'), 2000)
        })
    }

    totalPriceHandler() {
        $('.bitrix-vps__plan').change()
        const totalPriceEl = document.querySelector('.vps-bitrix__total');
        let totalPrice = totalPriceEl.value;
        this.periods.forEach(period => {
            if (period.classList.contains(this.plan.value)) {
                totalPrice = +period.querySelector('input:checked').value
            }
        })
        setTimeout(() => {
            totalPriceEl.querySelector('input').value = totalPrice;
            totalPriceEl.querySelector('.ginput_total').textContent = `${totalPrice.toLocaleString('ru-RU')} ${__('руб.', 'atlex')}`;
        }, 1)
    }

    changeImage() {
        const images = document.querySelectorAll('.vps-bitrix__images li');
        images.forEach(el => {
            if (!this.isHidden(el) && el.hasChildNodes()) {
                const logo = el.querySelector('.vps-bitrix__logo');
                logo.src = logo.src.replace(/bitrix-vps-(\d)/g, this.plan.value);
            }
        })
    }

    isHidden(el) {
        const style = window.getComputedStyle(el);
        return ((style.display === 'none') || (style.visibility === 'hidden'))
    }

    getFieldsID() {
        const fields = this.bitrixForm.querySelectorAll('.gfield');
        const ids = [];
        fields.forEach(field => {
            if (field.classList.contains('bitrix-vps__cond')) {
                ids.push(+field.getAttribute('id').replace(`field_${this.bitrixFormID}_`, ''));
            }
        })

        return ids;
    }

    getBitrixTariffsParams() {
        const tariffs = document.querySelectorAll('.vps-bitrix__tariff');
        tariffs.forEach(tariff => {
            this.tariffsData.push(JSON.parse(tariff.querySelector('.gfield_description').textContent))
        })
    }

    toggleProfit() {
        const profit = document.querySelector('.vps-bitrix__profit');
        this.periods.forEach(period => {
            if (!this.isHidden(period)) {
                const checked = period.querySelector('input:checked + label');
                if (checked.textContent.toLowerCase() === __('за месяц', 'atlex')) {
                    profit.classList.remove('vps-bitrix__profit--active');
                } else {
                    profit.classList.add('vps-bitrix__profit--active');
                }
            }
        })
    }

    getSliderName(array) {
        return array.find(value => /^vps-bitrix__name-/.test(value))
            ? array.find(value => /^vps-bitrix__name-/.test(value)).replace('vps-bitrix__name-', '')
            : null;
    }

}

export default VpsBitrix;
